import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../store";

const selectAdminAuthState = (state: RootState) => state.adminAuth;

export const selectAdminUser = createSelector(
  [selectAdminAuthState],
  (adminAuth) => adminAuth.admin
);

export const selectAdminIsAuthenticated = createSelector(
  [selectAdminAuthState],
  (adminAuth) => adminAuth.isAuthenticated
);

export const selectAdminIsLoading = createSelector(
  [selectAdminAuthState],
  (adminAuth) => adminAuth.isLoading
);

export const selectAdminError = createSelector(
  [selectAdminAuthState],
  (adminAuth) => adminAuth.error
);

export const selectAdminRole = createSelector(
  [selectAdminUser],
  (admin) => admin?.role
);

export const selectIsSuperAdmin = createSelector(
  [selectAdminRole],
  (role) => role === "SUPER_ADMIN"
);
